import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Ruler } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('tfg_token', r.data.token);
      onLogin(r.data.user);
    } catch (e) {
      setError(e.response?.data?.detail || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Ruler className="w-8 h-8 text-[#C5A028] mx-auto mb-3" />
          <h1 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#1C1917]">TrueFitGuide Admin</h1>
        </div>
        <form onSubmit={handleLogin} className="bg-white border border-[#E8E2D9] p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Username</label>
            <input type="text" value={email} onChange={e => setEmail(e.target.value)} required className="w-full p-3 border border-[#E8E2D9] bg-[#FAFAFA] focus:border-[#C5A028] focus:outline-none text-sm" data-testid="admin-email" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="w-full p-3 border border-[#E8E2D9] bg-[#FAFAFA] focus:border-[#C5A028] focus:outline-none text-sm" data-testid="admin-password" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full py-3 bg-[#1C1917] text-white text-sm font-medium hover:bg-[#C5A028] transition-colors disabled:opacity-50 flex items-center justify-center gap-2" data-testid="admin-login-btn">
            <Lock className="w-4 h-4" /> {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
